var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _mask2, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_790_30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.75C8 0.783502 8.7835 0 9.75 0H35.25C36.2165 0 37 0.783502 37 1.75V14H8V1.75Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.75C8 0.783502 8.7835 0 9.75 0H35.25C36.2165 0 37 0.783502 37 1.75V14H8V1.75Z",
    stroke: "#1976DB",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_790_30)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9866 4.70286C18.8604 4.75176 18.5922 4.94739 18.403 5.12672C17.2831 6.17007 17.5197 9.36533 18.75 9.93591C19.3809 10.2294 20.3115 10.1804 20.7689 9.80549C22.1096 8.71323 21.8572 5.28974 20.3746 4.76807C19.8541 4.57244 19.3809 4.55614 18.9866 4.70286ZM20.2169 7.55577C20.1538 8.76214 19.9329 9.1697 19.4913 8.89256C18.9392 8.51761 18.8919 6.51242 19.4282 5.95814C19.6648 5.7136 19.6963 5.7136 19.9803 6.07225C20.2326 6.382 20.2642 6.65914 20.2169 7.55577Z",
    fill: "#1976DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3768 4.73562C24.1149 5.3062 23.6417 7.81676 24.5092 9.28397C25.2033 10.4577 27.1276 10.3925 27.7269 9.18616C28.3421 7.96348 28.1528 5.95829 27.3484 5.15948C26.8752 4.68671 25.9288 4.49108 25.3768 4.73562ZM26.6859 7.24618C26.7332 8.0939 26.7017 8.33843 26.4335 8.66448C26.1181 9.05574 26.1023 9.05574 25.8184 8.7786C25.3925 8.33843 25.4083 6.28434 25.8499 5.95829C26.3231 5.59964 26.6071 6.0235 26.6859 7.24618Z",
    fill: "#1976DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7608 4.81703C29.1299 5.11047 28.7514 5.86038 28.6567 7.06675C28.499 8.84371 29.2876 10.1316 30.5337 10.1316C31.906 10.1316 32.6 9.21866 32.6 7.36019C32.6 5.72996 32.0006 4.78442 30.8649 4.654C30.5337 4.6214 30.0448 4.68661 29.7608 4.81703ZM31.1962 6.77331C31.3855 8.0938 31.0227 9.12085 30.4549 8.89261C30.1552 8.7785 30.029 8.32203 30.029 7.27868C30.029 5.64845 30.9754 5.25719 31.1962 6.77331Z",
    fill: "#1976DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3302 8.85994C22.0778 9.12078 22.0936 9.72397 22.3618 9.9685C22.9296 10.4413 23.8129 9.75657 23.5447 9.02297C23.4028 8.61541 22.6614 8.51759 22.3302 8.85994Z",
    fill: "#1976DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 4.61889C13.045 4.64781 12.9517 4.72634 12.8997 4.84481C12.8717 4.90818 12.8691 4.93573 12.8651 5.19884L12.8611 5.48538H12.7371C12.5399 5.48538 12.4466 5.53222 12.3759 5.66584C12.3226 5.76916 12.3226 5.87661 12.3759 5.97993C12.4466 6.11355 12.5399 6.16039 12.7371 6.16039H12.8624V6.28437V6.40835H12.7265C12.6105 6.40835 12.5785 6.41386 12.5225 6.44142C12.4052 6.49652 12.3386 6.60535 12.3386 6.73897C12.3386 6.82989 12.3693 6.90841 12.4266 6.9704C12.5012 7.05168 12.5599 7.07372 12.7185 7.08061L12.8624 7.0875L12.8651 8.45956L12.8691 9.83162L12.8997 9.9005C13.037 10.2077 13.4489 10.2091 13.5835 9.90188C13.6075 9.84815 13.6088 9.79581 13.6088 8.91829V7.99256H14.1459C14.9137 7.99119 15.0643 7.97603 15.3362 7.8672C15.6707 7.7322 15.9599 7.48011 16.1425 7.16189L16.1879 7.08336H16.3291C16.4144 7.08336 16.4957 7.0751 16.5357 7.0627C16.6823 7.01862 16.777 6.87673 16.765 6.71831C16.757 6.62188 16.733 6.56815 16.6717 6.50478C16.6104 6.44142 16.5344 6.40835 16.4451 6.40835H16.3678V6.28437V6.16039H16.4291C16.5317 6.16039 16.5944 6.13284 16.6677 6.05707C16.7383 5.98406 16.7676 5.91656 16.7676 5.82288C16.7676 5.69339 16.6917 5.57492 16.5757 5.51844C16.5157 5.48951 16.4877 5.48538 16.3411 5.48538L16.1745 5.484L16.1132 5.38482C15.836 4.94124 15.3961 4.66848 14.8777 4.61751C14.7044 4.60098 13.2356 4.60098 13.165 4.61889ZM14.9483 5.40824C14.9923 5.41926 15.0549 5.4413 15.0883 5.45645L15.1482 5.484H14.3859L13.6221 5.48538V5.43716V5.38895H14.2459C14.7364 5.38895 14.8857 5.39308 14.9483 5.40824ZM15.6214 6.28437V6.40835H14.6218H13.6221V6.28437V6.16039H14.6218H15.6214V6.28437ZM15.1816 7.09163C15.1816 7.10403 15.0349 7.16602 14.9496 7.18944C14.883 7.20735 14.759 7.21286 14.2459 7.21699L13.6221 7.22388V7.15362V7.08336H14.4018C14.831 7.08336 15.1816 7.08612 15.1816 7.09163Z",
    fill: "#1976DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57569 13.4483C8.61954 13.3681 8.70364 13.3182 8.79502 13.3182H35.746C35.8422 13.3182 35.9299 13.3735 35.9715 13.4603L41.0841 24.1421C41.1636 24.308 41.0426 24.5 40.8586 24.5H2.95198C2.76208 24.5 2.64151 24.2966 2.73265 24.13L8.57569 13.4483Z",
    stroke: "#1976DB",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0938,
    y: 16.5455,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.793,
    y: 19.382,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4902,
    y: 16.5455,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8867,
    y: 16.5455,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.39453,
    y: 19.382,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1875,
    y: 19.382,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.584,
    y: 19.382,
    width: 6.65639,
    height: 1.8909,
    rx: 0.945451,
    fill: "#1976DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6133,
    y: 28.7273,
    width: 9.09091,
    height: 1.81818,
    rx: 0.909091,
    fill: "#1976DB"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-2_790_30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 22.7273,
    width: 41.8182,
    height: 13.6364,
    rx: 1.75
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 22.7273,
    width: 41.8182,
    height: 13.6364,
    rx: 1.75,
    stroke: "#1976DB",
    strokeWidth: 6,
    mask: "url(#path-16-inside-2_790_30)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroSalesIcon);
export default __webpack_public_path__ + "static/media/zero-sales-icon.4956caeb4b0c323b4b083c013e9a38f5.svg";
export { ForwardRef as ReactComponent };